// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.black {
  position: relative;
  opacity: 0.5;
  border-radius: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/website/wizard/newrequest/newrequest.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;AADJ","sourcesContent":["\r\n\r\n.black{\r\n    position: relative;\r\n    opacity: 0.5;\r\n    border-radius: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
